import React, { useEffect, useMemo, useCallback, useContext } from "react";
import { format } from "date-fns";
import { useParams, useNavigate } from "react-router-dom";
import DataTable from "components/data-table";
import { useTakebacksByEmail } from "api/use-takebacks";
import { useTranslation } from "react-i18next";
import { calculateEstimate } from "lib/calculateEstimate";
import AuthContext from "contexts/AuthContext";

export default function CheckInTakebacks() {
  const { email } = useParams();
  const data = useTakebacksByEmail({ email });
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);

  const handleRowClick = useCallback(
    (sys_id) => {
      navigate(
        `${t("urls.store_trade_in_start")}?id=${sys_id}&e=${encodeURIComponent(
          email
        )}`
      );
    },
    [navigate, t, email]
  );
  const filteredData = useMemo(() => {
    return data
      ? data.filter(
          ({ rawTakeback, status_history, data }) =>
            rawTakeback.data?.returnMethod
              ?.replace("in_store_", "")
              .toLowerCase() === user.state.toLowerCase() &&
            status_history.find(
              ({ parent_status }) => parent_status !== "processed"
            )
        )
      : [];
  }, [data, user.state]);

  const formattedData = filteredData
    .map(
      ({
        number,
        rawTakeback,
        sys_id,
        sys_created_on,
        u_lego_in_store_verified_at,
        u_lego_presort_weight: weight,
      }) => {
        const currentWeight = weight;

        const estimate = calculateEstimate(currentWeight);
        const isCompleted = rawTakeback.takeback_processing_history_list.find(
          ({ parent_status }) => parent_status === "processed"
        );

        return {
          id: number,
          status: isCompleted
            ? "Trade-In Completed"
            : u_lego_in_store_verified_at
              ? "Trade-In Verified"
              : "Trade-In Created",
          dateCreated: sys_created_on
            ? format(new Date(sys_created_on), `MM/dd/yy HH:mm`)
            : "",
          quantity: currentWeight,
          value: `${t(`currency.symbol`)}${estimate.gift} `,
          onClick: () => handleRowClick(sys_id),
          sys_created_on, // Keep original date for sorting
        };
      }
    )
    .sort((a, b) => new Date(b.sys_created_on) - new Date(a.sys_created_on));

  useEffect(() => {
    if (formattedData.length === 1) {
      formattedData[0].onClick();
    }
  }, [formattedData]);

  if (!data) {
    return null;
  }

  return (
    <div className="flex flex-col px-6 py-4 items-left h-[calc(100vh-81px)]">
      <div className="flex flex-col align-left mb-6">
        <div>
          <h1 className="text-6xl pb-2 font-bold">Seller</h1>
          <span className="text-[#7E7D7D] text-3xl font-normal">{email}</span>
        </div>
        <div className="flex flex-col w-full mt-10">
          <h1 className="text-3xl font-bold">
            {formattedData.length > 1 ? "Multiple trade-ins found" : "Trade-in"}
          </h1>
          <DataTable data={formattedData} />
        </div>
      </div>
    </div>
  );
}
